type ToastErrorFn = (message: string) => void;

let handler: ToastErrorFn | null = null;

export function registerToastError(fn: ToastErrorFn | null): void {
  handler = fn;
}

export function emitToastError(message: string): void {
  handler?.(message);
}
